import { isEmpty } from 'lodash-es';
import { type PropsWithChildren } from 'react';

import { DEFAULT_DATASET_TYPE } from '../constants.js';
import { HoneycombDatasetTypeContext } from '../context/honeycomb-dataset-type.context.js';
import { useHoneycombData } from '../hooks/use-honeycomb-data.js';
import { getHoneycombDatasetType } from '../utils/get-honeycomb-dataset-type.js';

export const HoneycombDatasetTypeProvider = ({
  children,
}: PropsWithChildren) => {
  let honeycombDatasetType = DEFAULT_DATASET_TYPE;
  const data = useHoneycombData();
  if (!isEmpty(data)) {
    honeycombDatasetType = getHoneycombDatasetType(data);
  }

  return (
    <HoneycombDatasetTypeContext.Provider value={honeycombDatasetType}>
      {children}
    </HoneycombDatasetTypeContext.Provider>
  );
};
